import { render, staticRenderFns } from "./XAjaxDropdown.vue?vue&type=template&id=bfdec446"
import script from "./XAjaxDropdown.vue?vue&type=script&lang=js"
export * from "./XAjaxDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports